import React from 'react';
import { Button, Col, Row } from "reactstrap";

const Buttons = (props) => (
    <>
        <Col>
            {
                props.reset &&
                <Button color="info" onClick={props.reset}>
                    صفحه اول
                </Button>

            }
            {
                props.previousPage &&
                <Button color="info" onClick={props.previousPage}>
                    قبلی
                </Button>
            }

            {
                props.onSubmit &&
                <Button color="info" onClick={props.onSubmit} className="next-page-button">
                    بعدی
                </Button>
            }
        </Col>

    </>
);

export default Buttons;